import { fetchWithCredentials, handleErrorsStatus } from './httpService';
//import { mercadoPagoApiUrl, mercadoPagoConsultaUrl, mercadoPagoCreacionUrl, mercadoPagoApiCri } from 'utils/helpers/enviroment.helpers';
/**
 * Servicio para manejar las operaciones de pago con Mercado Pago
 */

/**
 * Consulta el estado de pago de un turno específico
 * @param {string|number} turnoId - ID del turno a consultar
 * @returns {Promise<Object|null>} - Datos del pago si existe, null si no existe
 * @throws {Error} - Error si la petición falla
 */
export const consultarEstadoPago = async (turnoId) => {
  try {
    //console.log('Consultando estado de pago para turno:', turnoId);
    
    const respuesta = await fetchWithCredentials(
      `${window.__CONFIG__.apiMercadoPago}${window.__CONFIG__.mercadoPagoConsultaUrl}${turnoId}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      }
    );

    // Si no existe pago (404), devolver null
    if (respuesta.status === 404) {
      
      return null;
    }

    // Verificar si la respuesta es exitosa
    if (!respuesta.ok) {
      const errorData = await respuesta.json().catch(() => ({ message: 'Error desconocido' }));
      throw new Error(errorData.message || `Error HTTP: ${respuesta.status}`);
    }

    const resultado = await handleErrorsStatus(respuesta);
    //console.log('Estado de pago consultado exitosamente:', resultado);
    
    return resultado;
    
  } catch (error) {
    //console.error('Error al consultar estado de pago:', error);
    
    // Lanzar error con mensaje claro
    if (error.message) {
      throw new Error(`Error al consultar estado de pago: ${error.message}`);
    } else {
      throw new Error('Error inesperado al consultar estado de pago. Por favor, inténtelo nuevamente.');
    }
  }
};

/**
 * Consulta si un turno está pagado (nuevo método simplificado)
 * @param {string|number} turnoId - ID del turno a consultar
 * @returns {Promise<boolean>} - true si está pagado, false si no está pagado
 * @throws {Error} - Error si la petición falla
 */
export const consultarSiTurnoEstaPagado = async (turnoId) => {
  try {
    //console.log('Consultando si el turno está pagado:', turnoId);
    
    const respuesta = await fetchWithCredentials(
      `${window.__CONFIG__.mercadoPagoApiCri}${window.__CONFIG__.mercadoPagoConsultaUrl}${turnoId}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      }
    );

    // Verificar si la respuesta es exitosa
    if (!respuesta.ok) {
      const errorData = await respuesta.json().catch(() => ({ message: 'Error desconocido' }));
      throw new Error(errorData.message || `Error HTTP: ${respuesta.status}`);
    }

    const resultado = await handleErrorsStatus(respuesta);
    //console.log('Consulta de pago exitosa:', resultado);
    
    // Devolver el valor booleano de 'pagado'
    return resultado?.pagado === true;
    
  } catch (error) {
    //console.error('Error al consultar si el turno está pagado:', error);
    
    // Lanzar error con mensaje claro
    if (error.message) {
      throw new Error(`Error al consultar estado de pago: ${error.message}`);
    } else {
      throw new Error('Error inesperado al consultar estado de pago. Por favor, inténtelo nuevamente.');
    }
  }
};

/**
 * Crea una preferencia de pago en Mercado Pago a través del API backend
 * @param {Object} datosTurno - Datos del turno para generar la preferencia de pago
 * @returns {Promise<Object>} - Respuesta completa del API que incluye preference e init_point
 * @throws {Error} - Error si la petición falla
 */
export const crearPreferenciaPago = async (datosTurno) => {
  try {
    //console.log('Creando preferencia de pago con datos:', datosTurno);
    
    const respuesta = await fetchWithCredentials(
      `${window.__CONFIG__.apiMercadoPago}${window.__CONFIG__.mercadoPagoCreacionUrl}`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(datosTurno)
      }
    );

    // Verificar si la respuesta es exitosa
    if (!respuesta.ok) {
      const errorData = await respuesta.json().catch(() => ({ message: 'Error desconocido' }));
      throw new Error(errorData.message || `Error HTTP: ${respuesta.status}`);
    }

    const resultado = await handleErrorsStatus(respuesta);
    //console.log('Preferencia de pago creada exitosamente:', resultado);
    
    return resultado;
    
  } catch (error) {
    //console.error('Error al crear preferencia de pago:', error);
    
    // Lanzar error con mensaje claro
    if (error.message) {
      throw new Error(`Error al crear preferencia de pago: ${error.message}`);
    } else {
      throw new Error('Error inesperado al crear preferencia de pago. Por favor, inténtelo nuevamente.');
    }
  }
};

